module.exports = __webpack_public_path__ + "img/header.ff1986a.jpg";